import { IAudienceFilterState } from "../actions";
import {
  SET_AUDIENCE_FILTER,
  CLEAR_AUDIENCE_FILTER,
} from "../actions/actions.types";

const INITIAL_STATE: IAudienceFilterState = {
  hearingNumber: "",
  startDate: null,
  finishDate: null,
  activeFilter: true,
  valueOptionDropDown: null,
  isCountyFilter: false,
  hearingTypeIdFilter: null,
  hearingSourceIdFilter: null,
  statusFilter: null,
  attendantFilterId: null,
  isFilterActive: false,
  userId: null,
};

const audienceFilterReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case SET_AUDIENCE_FILTER:
      return {
        ...state,
        ...action.payload,
      };
    case CLEAR_AUDIENCE_FILTER:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default audienceFilterReducer;
